exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast[data-v-26cbef65]{transition-property:opacity;border:1px solid;min-width:300px;max-width:500px;text-align:center;padding:10px 20px;opacity:1;position:relative;box-shadow:2px 2px 5px 0 rgba(0,0,0,.3)}.toast.success[data-v-26cbef65]{background:#38c172;border-color:#2eac4b;color:#fff}.toast.error[data-v-26cbef65]{background:#e45551;border-color:#b3515a;color:#fff}.toast.info[data-v-26cbef65]{background:#2564f5;border-color:#20459d;color:#fff}.toast ion-icon[data-v-26cbef65]{position:absolute;top:5px;right:5px;cursor:pointer}", ""]);

// exports
